// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1NK8q","infoBtn":"quickbooks_infoBtn__3e2Yf","formBox":"quickbooks_formBox__2XatK","formFooter":"quickbooks_formFooter__G_oxA"};